import React,{useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Checkbox from '@material-ui/core/Checkbox';
import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import Button from '@material-ui/core/Button';

const useRowStyles = makeStyles({
  root: {
    '& > *': {
      borderBottom: 'unset',
    }
  },
});

function Row(props) {
  const { row, handleAccept } = props;
  const [open, setOpen] = useState(false);
  const classes = useRowStyles();


  return (
    <React.Fragment>
      <TableRow className={classes.root}>
        <TableCell>
          <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row">
          {row.accountName}
        </TableCell>
        <TableCell align="right">{row.accountNumber}</TableCell>
        <TableCell align="right">{row.netAmount}</TableCell>
        <TableCell align="right">{row.bankName}</TableCell>
        <TableCell align="right">{row.accountEmail}</TableCell>
        <TableCell align="right">{new Date(row.createdAt).toLocaleDateString()}</TableCell>
        <TableCell align="right">{new Date(row.createdAt).toLocaleTimeString()}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box margin={1}>
              <Typography variant="h6" gutterBottom component="div">
                Accepted Proof
              </Typography>
              <img src={row.imageProofUrl} height="300px" widht="650px" />
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

export default function AcceptedProofTable({acceptedTable}) {
  return (
    <>
    <TableContainer component={Paper}>
      <Table aria-label="collapsible table">
        <TableHead>
          <TableRow>
            <TableCell />
            <TableCell>Account name</TableCell>
            <TableCell align="right">Phone Number</TableCell>
            <TableCell align="right">Amount</TableCell>
            <TableCell align="right">Bank Name</TableCell>
            <TableCell align="right">Email</TableCell>
            <TableCell align="right">Date</TableCell>
            <TableCell align="right">Time</TableCell>
            <TableCell />
          </TableRow>
        </TableHead>
        <TableBody>
          {acceptedTable.map((row) => (
            <Row key={row._id} row={row}/>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
    </>
  );
}
